namespace SorAraBul.Definitions {
    export interface CitiesForm {
        CountryId: Serenity.ServiceLookupEditor;
        Name: Serenity.StringEditor;
        StateId: Serenity.IntegerEditor;
        CityCode: Serenity.IntegerEditor;
    }

    export class CitiesForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Cities';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CitiesForm.init)  {
                CitiesForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(CitiesForm, [
                    'CountryId', w0,
                    'Name', w1,
                    'StateId', w2,
                    'CityCode', w2
                ]);
            }
        }
    }
}
